var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4113 10.4108C10.6785 10.1437 11.1118 10.1437 11.3789 10.4108L15.0004 14.0323L18.6219 10.4108C18.889 10.1437 19.3223 10.1437 19.5895 10.4108C19.8566 10.678 19.8566 11.1113 19.5895 11.3784L15.968 14.9999L19.5895 18.6214C19.8566 18.8885 19.8566 19.3218 19.5895 19.589C19.3223 19.8562 18.889 19.8562 18.6219 19.589L15.0004 15.9675L11.3789 19.589C11.1118 19.8562 10.6785 19.8562 10.4113 19.589C10.1441 19.3218 10.1441 18.8885 10.4113 18.6214L14.0328 14.9999L10.4113 11.3784C10.1441 11.1113 10.1441 10.678 10.4113 10.4108Z",
    fill: "#E0E1E3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.297174,
    x: 2,
    y: 2,
    width: 26,
    height: 26,
    rx: 13,
    stroke: "#E0E1E3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.ae3e70ba17b5d6218538457930b31282.svg";
export { ForwardRef as ReactComponent };